import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { hasExpiredPlanAtom, isLoggedInAtom } from 'app/atoms';
import { presentPayWallAtom } from 'app/atoms/ui';
import { StorageKey, useStoredValue } from 'app/lib/storage';

export const usePaywallAppLaunch = () => {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const hasExpiredPlan = useAtomValue(hasExpiredPlanAtom);
  const setModalVisible = useSetAtom(presentPayWallAtom);
  const [hasSubscriptionEndedPaywallAlreadyBeenSeen, setHasSubscriptionEndedPaywallAlreadyBeenSeen] =
    useStoredValue<boolean>(StorageKey.SubscriptionEndedPaywall, false);

  useEffect(() => {
    if (isLoggedIn && hasExpiredPlan && !hasSubscriptionEndedPaywallAlreadyBeenSeen) {
      setHasSubscriptionEndedPaywallAlreadyBeenSeen(true);
      setModalVisible(true);
    }
  }, [
    hasExpiredPlan,
    hasSubscriptionEndedPaywallAlreadyBeenSeen,
    isLoggedIn,
    setHasSubscriptionEndedPaywallAlreadyBeenSeen,
    setModalVisible,
  ]);
};
